import Tag from './src/index.vue'

export default Tag
